<div class="sidenav sidenav-offcanvas node-details-overlay position-fixed" id="mySidenav_{{viewType}}" aria-label="Comment">
  <div class="node-details-overlay-container">
    <header class="sidenav__header d-flex justify-content-between align-items-center">
      <div class="col-auto">
        <app-navigation-arrow [showNavigation]="showNavigation" [selectedNode]="selectedNode" [firstNode]="firstNode"
          [taxonomyData]="taxonomyData" [isAllNode]="isAllNode" (nextClickEvent)="onNextNavigationClick($event)"
          (previousClickEvent)="onPreviousNavigationClick($event)">
        </app-navigation-arrow>
      </div>

      <div class="col-auto">
        <button type="button" class="btn btn-icon" (click)="cancleComment()" id="close-note"
          aria-label="Close">
          <em class="material-icons-outlined font-4x" aria-hidden="true">close</em>
        </button>
      </div>
    </header>

    <div class="col-12 project-authoring pt-2">
      <app-item-details [currentTreeTab]="'tableview'" [showUserFriendlyPage]="showUserFriendlyPage"
        #itemDetailsComponent [viewLocation]="viewLocation" [isEditable]="isEditable" [showNodeType]="true" [selectedNode]="selectedNode"
        [taxonomyData]="dataForSidePanel" [treeTaxonomyData]="taxonomyData" [showAssociation]="showAssocciation"
        [showAdditionalMetadata]="showAdditionalMetadata" [showExemplar]="showExemplar" [showDocument]="showDocument"
        [itemExemplars]="dataForSidePanel && dataForSidePanel['itemExemplars'] ? dataForSidePanel['itemExemplars']:[]"
        [itemAssets]="dataForSidePanel && dataForSidePanel['itemAssets'] ? dataForSidePanel['itemAssets']:[]"
        [itemAssociations]="itemAssociationsData" [addedAdditionalMetadata]="addedAdditionalMetadata"
        [itemLinkedNodes]="itemLinkedNodes" [showEmptyFields]="showEmptyFields" [nodetypeList]="nodetypeList"
        [selectedNodeType]="selectedNodeType" (addActionEvent)="addActionEvent($event);" [showControls]="showControls"
        [showNavigation]="false" [isAllNode]="isAllNode" (nextClickEvent)="onNextNavigationClick($event)"
        [templateSelected] = "templateSelected"
        (previousClickEvent)="onPreviousNavigationClick($event)">
      </app-item-details>

    </div>
  </div>
</div>
